/**
 * gem-stone-filter.js  v12
 *
 * v11からの変更点:
 *   - data-stone-name をカンマ区切りで複数指定できるように対応。
 *     例: data-stone-name="サファイア,ティールサファイア"
 *     いずれかの石名にマッチすれば表示する。
 *   - hasExcludeWord() の除外判定も複数石名すべてに対して行う。
 *     いずれかの石名に除外ワードが含まれていれば除外しない。
 *
 * 絞り込み条件:
 *   1. data-original-text に codes のいずれかがカナで繋がらない形で含まれる
 *   2. data-original-text に [size]（例: [8]）が含まれる
 *   3. data-original-text に STONE_EXCLUDE_WORDS のいずれも含まれない
 *      ただし自ページの石名（data-stone-name）のいずれかにそのワードが含まれる場合は除外しない
 */

(function () {
  'use strict';

  /* -------------------------------------------------------
     除外ワードリスト
     ここに追加したワードを含むスウォッチは非表示になる。
     例: 'ラボグロウ' を追加すると「ピンクサファイア（ラボグロウ）」は除外される。
  ------------------------------------------------------- */
  var STONE_EXCLUDE_WORDS = [
    'ラボグロウ',
    'マーメイドカラー', 
    'テスト追加中', 
  ];

  function getFilterParams() {
    var el = document.getElementById('gemStoneFilter');
    if (!el) return null;
    var stoneName = (el.getAttribute('data-stone-name') || '').trim();
    var size = (el.getAttribute('data-stone-size') || '').trim();
    if (!stoneName || !size) return null;
    // カンマ区切りで複数石名に対応
    var codes = stoneName.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
    return { codes: codes, size: size };
  }

  function getStoneOptionEl() {
    var options = document.querySelectorAll('.mw-option[data-option-id]');
    for (var i = 0; i < options.length; i++) {
      var title = options[i].querySelector('.mw-option__title, .mw-label, [class*="title"]');
      if (title && title.textContent.indexOf('お石') !== -1) {
        return options[i];
      }
    }
    return null;
  }

  /**
   * 石名の一致チェック
   * 「ガーネット」が「マンダリンガーネット」にマッチしないよう、
   * stone_code の前後がカタカナ・ひらがなで繋がっていないことを確認する。
   * 括弧（全角・半角）は境界文字として扱わない。
   */
  function matchStoneCode(text, code) {
    var idx = 0;
    while (idx < text.length) {
      var pos = text.indexOf(code, idx);
      if (pos === -1) return false;

      var before = pos > 0 ? text.charAt(pos - 1) : '';
      var after  = pos + code.length < text.length ? text.charAt(pos + code.length) : '';

      var beforeIsKana = /[\u30A0-\u30FF\u3040-\u309F]/.test(before);
      var afterIsKana  = /[\u30A0-\u30FF\u3040-\u309F]/.test(after);

      if (!beforeIsKana && !afterIsKana) return true;

      idx = pos + 1;
    }
    return false;
  }

  /**
   * 除外ワードチェック
   * STONE_EXCLUDE_WORDS のいずれかが text に含まれていれば true を返す。
   * ただし、そのワードが stoneCodes（自ページの石名リスト）のいずれかに含まれている場合は除外しない。
   * 例: ラボグロウページでは「ラボグロウ」を除外しない。
   */
  function hasExcludeWord(text, stoneCodes) {
    for (var i = 0; i < STONE_EXCLUDE_WORDS.length; i++) {
      var word = STONE_EXCLUDE_WORDS[i];
      if (text.indexOf(word) === -1) continue;
      // 自ページの石名のいずれかにこのワードが含まれていれば除外しない
      var selfContains = stoneCodes.some(function(c) { return c.indexOf(word) !== -1; });
      if (!selfContains) return true;
    }
    return false;
  }

  /* -------------------------------------------------------
     お石エリア全体を隠す／表示する
     親要素を対象にするため APO の選択状態に影響しない
  ------------------------------------------------------- */

  function hideStoneOption() {
    var stoneOption = getStoneOptionEl();
    if (!stoneOption) return false;
    stoneOption.style.visibility = 'hidden';
    return true;
  }

  function showStoneOption() {
    var stoneOption = getStoneOptionEl();
    if (!stoneOption) return;
    stoneOption.style.visibility = 'visible';
  }

  /* -------------------------------------------------------
     フィルター処理
  ------------------------------------------------------- */

  function filterStoneSwatches(params) {
    var stoneOption = getStoneOptionEl();
    if (!stoneOption) return;

    var sizeTag = '[' + params.size + ']';

    var values = stoneOption.querySelectorAll('.mw-option__value[data-value-id]');
    values.forEach(function (container) {
      var textEl = container.querySelector('[data-original-text]');
      var original = textEl
        ? textEl.getAttribute('data-original-text')
        : container.textContent;

      // いずれかの石名にマッチすればOK
      var matchCode = params.codes.some(function(code) {
        return matchStoneCode(original, code);
      });
      var matchSize = original.indexOf(sizeTag) !== -1;
      var excluded  = hasExcludeWord(original, params.codes);

      if (matchCode && matchSize && !excluded) {
        container.style.removeProperty('display');
      } else {
        container.style.setProperty('display', 'none', 'important');
      }
    });

    // フィルター完了後にお石エリアを表示
    showStoneOption();
  }

  function selectFirstVisible() {
    var stoneOption = getStoneOptionEl();
    if (!stoneOption) return;
    var values = stoneOption.querySelectorAll('.mw-option__value[data-value-id]');
    for (var i = 0; i < values.length; i++) {
      if (values[i].style.display !== 'none') {
        var label = values[i].querySelector('label');
        if (label) label.click();
        break;
      }
    }
  }

  function init() {
    var params = getFilterParams();
    if (!params) return;

    // お石エリアが存在すればすぐ隠す、なければ出現を待つ
    if (!hideStoneOption()) {
      var waitTimer = setInterval(function () {
        if (hideStoneOption()) clearInterval(waitTimer);
      }, 50);
    }

    setTimeout(function () { filterStoneSwatches(params); }, 500);
    setTimeout(function () {
      filterStoneSwatches(params);
      selectFirstVisible();
    }, 1500);

    var target = document.querySelector('.mw-apo-container') || document.body;
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { filterStoneSwatches(params); }, 300);
    }).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();